import { NgModule } from '@angular/core';
import {
  BaseRouteReuseStrategy,
  provideRouter,
  RouteReuseStrategy,
  RouterModule,
  Routes,
  withComponentInputBinding,
} from '@angular/router';
import { loggedInGuard } from '@app/common/guards/logged-in.guard';
import { toHome, toLogin } from '@app/common/routes';
import { notLoggedInGuard } from '@app/common/guards/not-logged-in.guard';

class AppRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(): boolean {
    return false;
  }
}

const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/common/layouts/main/main-layout.component').then((m) => m.MainLayoutComponent),
    canActivate: [loggedInGuard(toLogin())],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadChildren: () => import('./features/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'orders',
        loadChildren: () => import('@app/features/order/order.module').then((m) => m.OrderModule),
      },
      {
        path: 'administration',
        loadChildren: () =>
          import('@app/features/administration/administration.module').then((m) => m.AdministrationModule),
      },
      {
        path: 'agencies',
        loadChildren: () => import('./features/agency/agency.module').then((m) => m.AgencyModule),
      },
      {
        path: 'companies',
        loadChildren: () => import('./features/company/company.module').then((m) => m.CompanyModule),
      },
      {
        path: 'plants',
        loadChildren: () => import('./features/plant/plant.module').then((m) => m.PlantModule),
      },
      {
        path: 'offers',
        loadChildren: () => import('@app/features/offer/offer.module').then((m) => m.OfferModule),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./features/product-config/product-config.module').then((m) => m.ProductConfigModule),
      },
      {
        path: 'fixed-cost',
        loadChildren: () => import('./features/fixed-cost/fixed-cost.module').then((m) => m.FixedCostModule),
      },
      {
        path: 'agency-thrones',
        loadChildren: () => import('./features/agency-throne/agency-throne.module').then((m) => m.AgencyThroneModule),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'support',
        loadChildren: () => import('./features/support/support.module').then((m) => m.SupportModule),
      },
      {
        path: 'inspections',
        loadChildren: () => import('@app/features/inspection/inspection.module').then((m) => m.InspectionModule),
      },
      {
        path: 'inspection-offers',
        loadChildren: () =>
          import('@app/features/inspection-offer/inspection-offer.module').then((m) => m.InspectionOfferModule),
      },
      {
        path: 'inspection-uploads',
        loadChildren: () =>
          import('@app/features/inspection-upload/inspection-upload.module').then((m) => m.InspectionUploadModule),
      },
      {
        path: 'profile',
        loadChildren: () => import('@app/features/profile/profile.module').then((m) => m.ProfileModule),
      },
      {
        path: 'pilot-companies',
        loadChildren: () => import('./features/pilot-company/pilot-company.module').then((m) => m.PilotCompanyModule),
      },
    ],
  },
  {
    path: 'auth',
    loadComponent: () => import('@app/common/layouts/basic/basic-layout.component').then((m) => m.BasicLayoutComponent),
    canActivate: [notLoggedInGuard(toHome())],
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '**',
    loadComponent: () => import('@app/common/layouts/basic/basic-layout.component').then((m) => m.BasicLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@app/common/components/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent),
      },
    ],
  },
];

@NgModule({
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy },
  ],
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
